import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { refreshAllowCookieIfAccepted, setHasVisitedWithinThirtyMinutes } from 'app/api/cookie';
import APIHealthCheck from 'app/components/providers/APIHealthCheck';
import ErrorBoundary from 'app/components/providers/ErrorBoundary';
import ReactQueryProvider from 'app/components/providers/ReactQueryProvider';
import UiThemeProvider from 'app/components/providers/UiThemeProvider';
import { ThirdPartyScripts } from 'app/components/scripts/ThirdPartyScripts';
import AppRoutes from 'app/routes';
import { setupBeamer } from 'app/services/beamer';
import ContextProvider from 'app/state/ContextProvider';

import GlobalCSSProvider from './components/providers/GlobalCSSProvider';

const App = () => {
  useEffect(() => {
    refreshAllowCookieIfAccepted();
  },
  []);

  useEffect(() => {
    setHasVisitedWithinThirtyMinutes();
  },
  []);

  useEffect(() => {
    setupBeamer();
  },
  []);

  return (
    <ContextProvider>
      <ReactQueryProvider>
        <Router>
          <UiThemeProvider>
            <ErrorBoundary>
              <GlobalCSSProvider>
                <ThirdPartyScripts />
                <APIHealthCheck>
                  <AppRoutes />
                </APIHealthCheck>
              </GlobalCSSProvider>
            </ErrorBoundary>
          </UiThemeProvider>
        </Router>
      </ReactQueryProvider>
    </ContextProvider>
  );
};

export default App;
